<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-focus-field-horizontal</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">費目情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="expense_form" v-model="valid" @submit.prevent>
              <v-select label="カテゴリ" :items="categoryItems" item-text="name" item-value="value" v-model="category" :rules="categoryRules" no-data-text="データがありません" dense outlined return-object>
                <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-select>
              <v-text-field label="費目名称" v-model="name" :rules="expenseNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="規格等" v-model="standard" :rules="standardNameRules" dense outlined></v-text-field>
              <v-text-field label="単位" v-model="display_unit" :rules="displayUnitRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="歩掛" v-model="percentage" :rules="percentageRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field :label="price_updated" v-model="unit_price" :rules="unitPriceRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-select label="集計費目" :items="aggregateItems" item-text="name" item-value="value" v-model="aggregate" :rules="aggregateSelectRules" no-data-text="データがありません" dense outlined return-object>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'ExpenseMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import CalcCommon from "@/helpers/calcCommon";
  import ExpenseApi from "@/api/expense-api";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import Rule from "@/validation/rules";

  export default {
    name: "EditExpenseMaster",
    components: {
      CustomDialog
    },
    data: () => ({
      loading: false,
      // フォームの項目
      name: '',
      standard: '',
      display_unit: '',
      percentage: 0,
      unit_price: 0,
      price_updated: "単価",
      category: null,
      categoryItems: [],
      aggregate: null,
      aggregateItems: [],

      // 更新ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      editId: null,

      // バリデーション
      valid: true,
      expenseNameRules: Rule.expenseNameRules,
      standardNameRules: Rule.standardNameRules,
      displayUnitRules: Rule.displayUnitRules,
      percentageRules: Rule.percentageRules,
      unitPriceRules: Rule.unitPriceRules,
      categoryRules: Rule.categoryRules,
      aggregateSelectRules: Rule.aggregateSelectRules
    }),
    created () {
      this.initialize();
    },
    watch: {
      percentage (value) { this.percentage = this.stringFormat(value); },
      unit_price (value) { this.unit_price = this.stringFormat(value); },
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.expenseApi = new ExpenseApi();
        // 費目IDをルートパラメータから取得
        this.editId = this.$route.params.id;
        const promise = this.expenseApi.info(this.editId);
        promise.then(response => {
            this.name = response.data.body.expense_info.name;
            if (response.data.body.expense_info.standard) {
              this.standard = response.data.body.expense_info.standard;
            }
            this.display_unit = response.data.body.expense_info.display_unit;
            this.percentage = response.data.body.expense_info.percentage;
            this.unit_price = response.data.body.expense_info.unit_price;
            this.price_updated = "単価 (更新日時: " + response.data.body.expense_info.price_updated + ")";
            for (var category of response.data.body.category_info) {
              this.categoryItems.push({
                  name: category.name,
                  value: category.id
              });
            }
            for (var aggregate of response.data.body.aggregate_info) {
              this.aggregateItems.push({
                  name: aggregate.name,
                  value: aggregate.id
              });
            }
            this.category = this.categoryItems.find(item => { return item.value === response.data.body.expense_info.category_id });
            this.aggregate = this.aggregateItems.find(item => { return item.value === response.data.body.expense_info.aggregate_id });
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "ExpenseMaster" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      stringFormat(value) {
        var result = value.toString()
        while (result.match(/[０-９]/g)) {
          result = result.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
          });
        }
        return result;
      },
      // 更新ボタン押下時イベント
      checkDialog () {
        this.dialogTitle = '更新しますか？';
        this.dialogItems = [
          { name: 'カテゴリ', value: this.category.name },
          { name: '費目名称', value: this.name },
          { name: '規格等', value: this.standard },
          { name: '単位', value: this.display_unit },
          { name: '歩掛', value: this.percentage },
          { name: '単価', value: CalcCommon.addFigure(this.unit_price) },
          { name: '集計費目', value: this.aggregate.name }
        ];
        this.dialogDrawer = true;
      },
      dialogCancel() {
        this.dialogDrawer = false;
      },
      // 確認ダイアログの「更新」確定ボタン押下イベント
      submit() {
        if (this.$refs.expense_form.validate()) {
          this.isLoading();
          const params = {
            category_id: String(this.category.value),
            name: this.name,
            standard: this.standard,
            display_unit: this.display_unit,
            percentage: this.percentage,
            unit_price: this.unit_price,
            aggregate_id: String(this.aggregate.value)
          };
          const promise = this.expenseApi.update(this.editId, params);
          promise.then((response) => {
              this.$emit('success', response.data.message);
              this.$router.push({ name: 'ExpenseMaster' });
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
              if (error.response.data.status == statusList.status.authError) {
                this.dialogDrawer = false;
                this.$emit('logoutConform');
              } else {
                this.$emit("error",error.response.data.message);
              }
            } else {
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.isLoading();
          });
        }
      }
    },
  };
</script>
